<template>
  <v-col cols="12" xl="6">
    <v-container fluid>
      <v-row no-gutters>
        <div class="stats-title">
          <h3>{{ $t(title) }}</h3>
          <v-tooltip
            v-if="tooltip"
            bottom
            :max-width="400"
            nudge-right="100%"
            transition="fade-transition"
            content-class="tooltip-content">
            <template v-slot:activator="{on, attrs}">
              <v-icon class="fa-light fa-circle-info click" color="tertiary" dense v-on="on" v-bind="attrs" />
            </template>
            <span v-html="$t(tooltip)"></span>
          </v-tooltip>
        </div>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <CardTrend
            :loading="loading"
            :title1="$t('honda.dashboard.stats.offers.created')"
            :value1="data.offers"
            :percent="data.offersYoy"
            :year="data.year" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardTrend
            :loading="loading"
            :title1="$t('honda.dashboard.stats.offers.closed-sale')"
            :value1="data.coiCreated"
            :subtitle="$t('honda.dashboard.stats.offers.coi-created')"
            :percent="data.coiCreatedYoy"
            :year="data.year" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardBars
            :loading="loading"
            :title="$t('honda.dashboard.stats.offers.pending-delivery')"
            :current="data.toBeDelivered"
            :labels="[
              $t('honda.dashboard.stats.offers.invoiced'),
              $t('honda.dashboard.stats.offers.confirmed'),
              $t('honda.dashboard.stats.offers.quoted'),
              $t('honda.dashboard.stats.offers.coi-created'),
              $t('honda.dashboard.stats.offers.accepted'),
            ]"
            :data="[
              data.currentInvoiced,
              data.currentConfirmed,
              data.currentQuote,
              data.currentCoiAccepted,
              data.currentAccepted,
            ]" />
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script lang="ts">
import {defineComponent} from '@vue/composition-api'

import CardBars from '@/components/metrics/CardBars.vue'
import CardTrend from '@/components/metrics/CardTrend.vue'

export default defineComponent({
  name: 'StatsOffers',
  components: {
    CardBars,
    CardTrend,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
})
</script>
